import { type Reading, label } from './liveModel';

const escape = (value: unknown) =>
  String(value ?? 'Unknown').replace(
    /[&<>"']/g,
    (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]!,
  );

/** A complete, printable data report, independent of table pagination and chart viewport. */
export function printableReport(title: string, source: string, range: string, rows: Array<Reading>): string {
  return `<!doctype html><html lang="en"><head><meta charset="utf-8"><title>${escape(title)}</title><style>
  @page { size: A4; margin: 16mm; } body { font-family: Arial, sans-serif; color: #0F0C08; background: #FFFFFF; } h1 { font-family: 'Times New Roman', serif; font-size: 28pt; color: #0F464F; } h2 { font-family: 'Times New Roman', serif; font-size: 18pt; color: #0F464F; break-after: avoid; } p { overflow-wrap: anywhere; } table { width: 100%; border-collapse: collapse; margin-bottom: 20pt; font-size: 10pt; } th { background: #0F464F; color: #FFFFFF; text-align: left; } th,td { padding: 6pt; border-bottom: 1px solid #0F464F; overflow-wrap: anywhere; } td:last-child { text-align: right; } tr { break-inside: avoid; } thead { display: table-header-group; }
  </style></head><body><h1>${escape(title)}</h1><p>Source: ${escape(source)}</p><p>Period: ${escape(range)} · AUD or decimal ratios · Unknown is not zero.</p><p>All ${rows.length} returned rows, including the selected comparison window.</p>${rows
    .map(
      (row, index) =>
        `<h2>Source row ${index + 1}</h2><table><thead><tr><th>Measure or dimension</th><th>Value</th></tr></thead><tbody>${Object.entries(
          row,
        )
          .map(
            ([key, value]) =>
              `<tr><td>${escape(label(key))}</td><td>${escape(typeof value === 'number' ? value.toLocaleString('en-AU', { maximumFractionDigits: 8 }) : value)}</td></tr>`,
          )
          .join('')}</tbody></table>`,
    )
    .join('')}</body></html>`;
}
